<app-navbar></app-navbar>
<main [@routeAnimations]="prepareRoute(outlet)" class="page-wrapper">
    <app-spinner></app-spinner>
    <router-outlet #outlet="outlet"></router-outlet>
</main>
<app-footer></app-footer>
<app-scroll-to-top></app-scroll-to-top>